(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Scrolling-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Keeps the same speed (pixels per second) whatever the message length or screen size. */
    function setup(root) {
      (root || document).querySelectorAll('[data-marquee]').forEach(function (el) {
        var groups = el.querySelectorAll('.marquee__group');
        var group = groups[0];
        if (!group) return;
        /* On very wide screens, repeat the messages so the band never shows a gap. */
        if (!el.dataset.base) el.dataset.base = group.innerHTML;
        var guard = 0;
        while (group.getBoundingClientRect().width < el.getBoundingClientRect().width && guard < 8) {
          groups.forEach(function (g) { g.insertAdjacentHTML('beforeend', el.dataset.base); });
          guard++;
        }
        var pxPerSec = Number(el.dataset.speed) || 60;
        var width = group.getBoundingClientRect().width;
        if (width > 0) el.style.setProperty('--mq-duration', (width / pxPerSec).toFixed(2) + 's');
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(); });
    else setup();
    window.addEventListener('load', function () { setup(); });
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(setup, 200); });
    document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
    document.addEventListener('shopify:block:select', function (e) { setup(e.target.closest('.shopify-section')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Keeps the same speed (pixels per second) whatever the message length or screen size. */
    function setup(root) {
      (root || document).querySelectorAll('[data-marquee]').forEach(function (el) {
        var groups = el.querySelectorAll('.marquee__group');
        var group = groups[0];
        if (!group) return;
        /* On very wide screens, repeat the messages so the band never shows a gap. */
        if (!el.dataset.base) el.dataset.base = group.innerHTML;
        var guard = 0;
        while (group.getBoundingClientRect().width < el.getBoundingClientRect().width && guard < 8) {
          groups.forEach(function (g) { g.insertAdjacentHTML('beforeend', el.dataset.base); });
          guard++;
        }
        var pxPerSec = Number(el.dataset.speed) || 60;
        var width = group.getBoundingClientRect().width;
        if (width > 0) el.style.setProperty('--mq-duration', (width / pxPerSec).toFixed(2) + 's');
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(); });
    else setup();
    window.addEventListener('load', function () { setup(); });
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(setup, 200); });
    document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
    document.addEventListener('shopify:block:select', function (e) { setup(e.target.closest('.shopify-section')); });
  })();

  } catch(e) { console.error(e); }
})();
})();
